import React, { useEffect, useState } from "react";
import Tabs from "../Tabs/Tabs";
import Button from "../Button/Button";
import { getPhaseTitle, getActivities, isPhaseValidate } from "./FormFormat";
import "./format-by-phase.scss";

const FormByPhase = (props) => {
  const {
    accepting,
    phaseNo,
    formShowInitialPhase,
    touched,
    phases,
    errors,
    canceltext,
    sendtext,
    onCancel,
    onSubmit,
    formShowPendingCount
  } = props;
  const [activePhase, setActivePhase] = useState(0);
  const [nextPhase, setNextPhase] = useState({});

  const getPhase = (phase) => phase.phaseNo == phaseNo;

  useEffect(() => {
    if(formShowInitialPhase === 1 && phases.length > 0){
      setActivePhase(phases[0].phaseNo)
    } else {
      setActivePhase(phaseNo);
    }
  }, []);

  useEffect(() => {
    setNextPhase(phases.find(getPhase) || {});
  }, [phaseNo]);

  const handleNextPhase = () => {
    if (activePhase !== phaseNo) {
      setActivePhase(phaseNo);
    }
  };

  const isShowNextPhase = () => {
    const activePhaseIndex = phases.findIndex(
      (phase) => phase.phaseNo === activePhase
    );
    const nextPhaseIndex = phases.findIndex(
      (phase) => phase.phaseNo === nextPhase.phaseNo
    );
    return (
      !accepting &&
      activePhase !== nextPhase.phaseNo &&
      activePhaseIndex + 1 !== nextPhaseIndex &&
      !!nextPhase.title
    );
  };

  const isAllActivitiesNonPending = (elements) => {
    return elements.every((elem) => !elem.pending);
  };

  const getPhaseClassName = (elements) => {
    if (!elements.length) {
      return "dcrfrom-tabs__option--nonvisible";
    }

    if (isAllActivitiesNonPending(elements)) {
      return "dcrfrom-tabs__option--nonpending";
    }

    if (isPhaseValidate(elements, touched, errors)) {
      return "dcrfrom-tabs__option--validate";
    }

    return "";
  };

  const isLastPhase = (phases, phase, nextPhase) => {
    const { phaseNo } = phases.slice(-1).pop() || {};
    return phaseNo === phase.phaseNo && phaseNo === nextPhase.phaseNo;
  };

  return (
    <Tabs
      className="dcrfrom-phase"
      activeTab={activePhase}
      setActiveTab={setActivePhase}
      nextTab={nextPhase.phaseNo}
    >
      {phases.map((phase) => {
        const { phaseNo, title, description, elements } = phase;
        return (
          <div
            key={phaseNo}
            className={getPhaseClassName(elements, phaseNo)}
            id={phaseNo}
            label={getPhaseTitle(title, elements, formShowPendingCount, true)}
          >
            {getActivities({
              touched,
              errors,
              description,
              elements,
              ...props,
              phaseNo,
            })}
            <div className="phase-footer-wrapper">
              <Button className="activity-form__cancelbtn" onClick={onCancel}>
                {canceltext}
              </Button>
              {isLastPhase(phases, phase, nextPhase) ? (
                <Button
                  className="next-btn"
                  disabled={!accepting}
                  onClick={onSubmit}
                >
                  {sendtext}
                </Button>
              ) : (
                <div className="next-btn-wrapper">
                  <Button className="next-btn" onClick={handleNextPhase}>
                    Next
                  </Button>
                  {isShowNextPhase() && (
                    <label className="next-btn__info">
                      (Next page is {nextPhase.title})
                    </label>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </Tabs>
  );
};

export default React.memo(FormByPhase);
